export default __webpack_public_path__ + "static/media/projecaoIcone.f11e3a91.svg";